/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_Cannot_FinishInputs */



/**
* | output |
* | --- |
* | "Cannot finish from this state" |
*
* @param {Err_Tournament_Cannot_FinishInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_cannot_finish = /** @type {((inputs?: Err_Tournament_Cannot_FinishInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_Cannot_FinishInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Impossible de terminer depuis cet état")
	if (locale === "es") return /** @type {LocalizedString} */ ("No es posible finalizar desde este estado")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Não é possível finalizar a partir deste estado")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile terminare da questo stato")
	return /** @type {LocalizedString} */ ("Cannot finish from this state")
});